// Product Card Reviews
  window.addEventListener("load", function () {
    setTimeout(function () {
      document.querySelectorAll('.jdgm-prev-badge').forEach(function(el) {
        var rating = parseFloat(el.getAttribute("data-average-rating")) || 0;
        var count = parseInt(el.getAttribute("data-number-of-reviews")) || 0;

        // hide if no reviews
        if (count === 0) {
          el.closest('.jdgm-widget').style.display = "none";
          return;
        }

        // hide if rating < 2
        if (rating < 3) {
          el.closest('.jdgm-widget').style.display = "none";
          return;
        }

        // IMPORTANT → SHOW the badge
        el.style.display = "block";
        el.closest('.jdgm-widget').style.display = "block";
      });
    });
  });